export default "__VITE_ASSET__hdl6dV_j__"